import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { first, map, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { AuthState } from '../_state/auth.state';
import { AuthService } from './auth.service';
@Injectable()
export class CustomerGuard {
  constructor(private store: Store, private authService: AuthService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.store.select(AuthState.fetch()).pipe(
      first(),
      map((loginInfo) => {
        if (
          loginInfo?.isAuthenticated &&
          (loginInfo?.type == 'Customer' || loginInfo?.type == 'CustomerStaff')
        ) {
          return true;
        }
        this.authService.logIn();
        return false;
      })
    );
  }
}
